export default __webpack_public_path__ + "static/media/twitter-logo.08dc2d54.svg";